module.exports = __webpack_public_path__ + "static/media/background_10.e5ae392d.png";